<template>
  <v-btn :disabled="!logs || logs.length == 0" small :color="getColor" @click="ignore()">
    <v-icon small class="mr-2">{{ getIcon }}</v-icon>
    {{ stateText }}
  </v-btn>
</template>
<script>
  export default {
    props: {
      logs: Array,
    },
    computed: {
      getColor() {
        return this.isIgnore ? 'info' : 'info'
      },
      getIcon() {
        return this.isIgnore ? 'done' : 'clear'
      },
      isIgnore() {
        return this.logs.filter(log => !log.ignore).length > 0 || this.logs.length == 0
      },
      stateText() {
        return this.isIgnore ? 'Checkout' : 'Uncheck'
      },
    },
    methods: {
      ignore() {
        if (!this.logs) {
          return
        }

        let state = this.isIgnore

        this.logs.forEach(log => {
          log.ignore = state
        })
      },
    },
  }
</script>